import { render } from "./Basics.vue?vue&type=template&id=71db52b2&scoped=true"
import script from "./Basics.vue?vue&type=script&lang=ts"
export * from "./Basics.vue?vue&type=script&lang=ts"

import "./Basics.vue?vue&type=style&index=0&id=71db52b2&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-71db52b2"

export default script